import type { FreeStringVFrame } from '@festina/life-general-types/life'
import { FormikTextInput } from '@festina-life/ui/formikForms'
import get from 'lodash-es/get'
import type { ComponentProps } from 'react'

import { isFieldRequired } from '../../forms/formUtility'
import { useLifeFormikContext } from '../../forms/useLifeFormikContext'
import {
  isDontUseVFrame,
  isFixedVFrame,
} from '../../forms/yup/validation/types'
import { isVFrameWithDefaultValue } from '../../forms/yup/validation/yupValidationUtils'
import { useFieldVFrame } from '../useFieldVFrame'
import type { InputPropsFromFormik } from './types'

export type LifeTextInputProps = InputPropsFromFormik<
  ComponentProps<typeof FormikTextInput>
>

/**
 *  Text input used in life forms. This should be used in those cases where a frame exists to validate the input values.
 */
export function LifeTextInput({
  name,
  disabled,
  ...props
}: LifeTextInputProps) {
  const { values, setFieldValue } = useLifeFormikContext()
  const frameStatus = useFieldVFrame(name)

  if (isDontUseVFrame(frameStatus)) {
    return null
  }

  const value = get(values, name as string)
  const fixed = isFixedVFrame(frameStatus)
  const isRequired = isFieldRequired(frameStatus)

  const defaultValue = isVFrameWithDefaultValue(frameStatus)
    ? (frameStatus as FreeStringVFrame)?.defaultValue
    : null

  return (
    <FormikTextInput
      name={name}
      disabled={fixed || disabled}
      value={fixed ? frameStatus.value : value}
      defaultValue={defaultValue ?? undefined}
      onDefaultValueClick={() => setFieldValue(name, defaultValue)}
      isRequired={isRequired}
      hasRightColumnAlways
      {...props}
    />
  )
}
